module.exports = __webpack_public_path__ + "img/profile.34d66504.png";